import React, { useEffect } from 'react';
import { DexSearchStore } from '@zen-dex/utils';
import OrderBook from './components/OrderBook';

export default function OrderBookContainer({ base, quote }) {
  const {
    actions: { search },
  } = DexSearchStore.useStore();

  useEffect(() => {
    if (base && quote) {
      search({ base, quote });
    }
  }, [base, quote, search]);

  return <OrderBook />;
}
